'use strict';

var util = angular.module('gymsystem.util');

util.directive('economycertifycosts', ['$rootScope', '$modal', 'util', 'server', 'live', 'confirm', function($rootScope, $modal, util, server, live, confirm) {
    return {
        restrict: 'E',
        template: '<customertable config="config" />',
        scope: {
            settings: '='
        },
        link: function($scope) {

            $scope.loadingStatus = {};
            $scope.types = $scope.settings && $scope.settings.types;

            var rows = [
                { id: 'receipt', title: 'Receipts', costs: [] },
                { id: 'supplierinvoice', title: 'Supplier invoices', costs: [] },
                { id: 'travelcompensation', title: 'Travel bills', costs: [] },
                { id: 'outlay', title: 'Outlays', costs: [] },
                { id: 'valuecard', title: 'Value cards', costs: [] }
            ];

            var getCosts = function() {
                server.get('/api/economy/cost/get').then(function(costs) {
                    var types = {};

                    costs.forEach(function(cost) {
                        cost = $rootScope.transformCost(cost);

                        if (!types[cost.type]) {
                            types[cost.type] = [cost];
                        } else {
                            types[cost.type].push(cost);
                        }

                        Object.keys(types).forEach(function(type) {
                            var row = _.findWhere(rows, { id: type });
                            if (!row) { return; }
                            row.costs = types[type];
                        });
                        _.pluck(rows, 'id').forEach(function(type) {
                            if (types[type]) { return; }
                            _.findWhere(rows, { id: type }).costs = [];
                        });
                    });
                    $scope.config.control.update();
                });
            };
            getCosts();

            var getRowAmount = function(row) {
                return _.reduce(row.costs, function(sum, cost) { return sum + (cost.amount || 0); }, 0);
            };

            var validateCost = function(cost) {

                var isValid = function(field) {
                    var value = cost[field];
                    if (!value && !_.isNumber(value)) { return false; }
                    return true;
                };

                switch (cost.type) {
                    case 'receipt': return _.every(['date', 'amount', 'accountingTemplate'], isValid);
                    case 'outlay': return _.every(['date', 'amount', 'accountingTemplate', 'payoutAccount'], isValid);
                    case 'valuecard': return _.every(['date', 'supplier_id', 'amount', 'payoutAccount'], isValid);
                    case 'supplierinvoice':
                        var values = ['supplier_id', 'amount', 'invoiceDate', 'dueDate', 'accountingTemplate'];
                        if (!cost.autoPayout) { values.push('payoutAccount'); }
                        return _.every(values, isValid);
                    case 'travelcompensation':
                        if (!_.every(['payoutAccount', 'comment', 'departure', 'journeyHome'], isValid)) {
                            return false;
                        }
                        if (cost.companyOfferedFood) {
                            if (!_.every(['halfDaysBreakfast', 'halfDaysLunchDinner', 'fullDaysBreakfast', 'fullDaysLunchDinner'], isValid)) {
                                return false;
                            }
                        }
                }

                return true;
            };

            var confirmAll = function(row) {
                $scope.loadingStatus.loading = true;
                var validCosts = row.costs.filter(validateCost);
                if (!validCosts.length) { return; }
                var ids = _.pluck(validCosts, 'id');
                var message = ids.length == 1 ? util.t('Do you want to confirm the this cost?') : util.t('Do you want to confirm {0} costs?').format(ids.length);
                confirm.show(message, { ladda: true }).then(function(resolve) {
                    var stopLoading = function() {
                        $scope.loadingStatus.loading = false;
                        resolve();
                    };
                    server.post('/api/economy/cost/certify', ids, null, 'Successfully certified costs', 'Failed to certify costs').then(stopLoading, stopLoading);
                }, function() {
                    $scope.loadingStatus.loading = false;
                });
            };

            var rowIsEmpty = function(row) {
                return !row.costs.length;
            };

            var confirmDisabled = function(row) {
                if (rowIsEmpty(row)) { return true; }
                return !!_.every(row.costs, function(cost) { return !validateCost(cost); });
            };

            var showAll = function(row) {
                $modal.open({
                    templateUrl: 'components/widgets/economycertifycosts/certifycostsmodal.html',
                    windowClass: 'huge-modal-window',
                    controller: 'EconomyCertifyCostsModalCtrl',
                    resolve: {
                        item: function() {
                            return row;
                        }
                    }
                });
            };

            var getApprovedCount = function(row) {
                var approved = _.filter(row.costs, validateCost);
                return approved.length + ' ' + util.t('of') + ' ' + row.costs.length;
            };

            $scope.config = {
                getItems: function() {
                    return ($scope.types && $scope.types.length) ? $scope.types.map(function(t) { return _.findWhere(rows, { id: t }); }) : rows;
                },
                rowClick: showAll,
                hideSearch: true,
                columns: [
                    { field: 'title', title: 'Type', getValue: function(row) { return util.t(row.title); } },
                    { field: 'count', title: 'Count', getValue: function(row) { return row.costs.length; } },
                    { field: 'amount', title: 'Amount', getValue: getRowAmount, format: 'price' },
                    { field: 'valid', title: 'Approved', getValue: getApprovedCount }
                ],
                buttons: [
                    { title: 'Confirm all', buttonClass: 'btn-success', onClick: confirmAll, loading: function() { return $scope.loadingStatus.loading; }, disabled: confirmDisabled },
                    { title: 'Show', buttonClass: 'btn-info', onClick: showAll, disabled: rowIsEmpty }
                ]
            };

            live.subscribe({
                type: 'cost',
                callback: getCosts
            });
        }
    };
}]);

util.controller('EconomyCertifyCostsModalCtrl', ['$rootScope', '$scope', '$modal', 'server', 'fileManager', 'live', 'confirm', 'util', 'item',
    function($rootScope, $scope, $modal, server, fileManager, live, confirm, util, item) {
    $scope.title = item.title;
    $scope.costs = item.costs;

    $scope.loadingStatus = {};

    var isSupplierInvoice = function() {
        return item.id == 'supplierinvoice';
    };
    var isTravelCompensation = function() {
        return item.id == 'travelcompensation';
    };
    var isOutlay = function() {
        return item.id == 'outlay';
    };
    var isValueCard = function() {
        return item.id == 'valuecard';
    };

    var validateCost = function(cost) {

        var isValid = function(field) {
            var value = cost[field];
            if (!value && !_.isNumber(value)) { return false; }
            return true;
        };

        switch (cost.type) {
            case 'receipt': return _.every(['date', 'amount', 'accountingTemplate'], isValid);
            case 'outlay': return _.every(['date', 'amount', 'accountingTemplate', 'payoutAccount'], isValid);
            case 'valuecard': return _.every(['date', 'supplier_id', 'amount', 'payoutAccount'], isValid);
            case 'supplierinvoice':
                var values = ['supplier_id', 'amount', 'invoiceDate', 'dueDate', 'accountingTemplate'];
                if (!cost.autoPayout) { values.push('payoutAccount'); }
                return _.every(values, isValid);
            case 'travelcompensation':
                if (!_.every(['payoutAccount', 'comment', 'departure', 'journeyHome'], isValid)) {
                    return false;
                }
                if (cost.companyOfferedFood) {
                    if (!_.every(['halfDaysBreakfast', 'halfDaysLunchDinner', 'fullDaysBreakfast', 'fullDaysLunchDinner'], isValid)) {
                        return false;
                    }
                }
        }

        return true;
    };

    var confirmCosts = function(costs) {
        if (!costs) {
            costs = $scope.costs;
        }
        if (!Array.isArray(costs)) {
            costs = [costs];
        }
        costs = costs.filter(validateCost);
        if (!costs.length) { return; }

        $scope.loadingStatus.loading = true;
        var ids = _.pluck(costs, 'id');
        var message = ids.length == 1 ? util.t('Do you want to confirm the this cost?') : util.t('Do you want to confirm {0} costs?').format(ids.length);
        confirm.show(message, { ladda: true }).then(function(resolve) {
            var stopLoading = function() {
                $scope.loadingStatus.loading = false;
                resolve();
            };
            server.post('/api/economy/cost/certify', ids, null, 'Successfully certified costs', 'Failed to certify costs').then(stopLoading, stopLoading);
        }, function() {
            $scope.loadingStatus.loading = false;
        });
    };

    var reject = function(cost) {
        $scope.loadingStatus.loading = true;
        confirm.show('Are you sure you want to reject this cost?', { ladda: true }).then(function(resolve) {
            var stopLoading = function() {
                $scope.loadingStatus.loading = false;
                resolve();
            };

            $modal.open({
                templateUrl: 'views/addmodal.html',
                resolve: {
                    cost: function() { return cost; }
                },
                controller: ['$scope', '$controller', 'server', 'cost', function($scope, $controller, server, cost) {
                    $controller('AddCtrl', {$scope: $scope});
                    $scope.loadingStatus = {};
                    $scope.title = 'Reject cost';
                    $scope.submitTitle = 'Reject';
                    $scope.hideSubmitButton = true;

                    $scope.getButtonClass = function() {
                        return 'btn-danger';
                    };

                    $scope.submit = function() {
                        $scope.loadingStatus.loading = true;
                        var item = $scope.getSubmitItem();
                        server.post('/api/economy/cost/reject', { costs: [cost.id], reason: item.reason }, null, 'Cost was rejected successfully', 'Failed to reject cost').then(function(result) {
                            if (result.success) { $scope.$close(); }
                            $scope.loadingStatus.loading = false;
                        }, function() {
                            $scope.loadingStatus.loading = false;
                        });
                    };

                    $scope.fields = [
                        { name: 'reason', title: 'Reason', type: 'textarea', required: false }
                    ];
                }]
            }).result.then(stopLoading, stopLoading);
        }, function() {
            $scope.loadingStatus.loading = false;
        });
    };

    var show = function(cost) {
        $modal.open({
            templateUrl: 'components/widgets/economycertifycosts/costlist.html',
            controller: 'EconomyCostListModalCtrl',
            resolve: {
                cost: function() {
                    return cost;
                }
            }
        });
    };

    var change = function(cost) {
        var options = angular.copy(cost);
        options.origin = cost.id;
        if (cost.type == 'travelcompensation') {
            $modal.open({
                templateUrl: 'views/addtravelcompensationcostmodal.html',
                controller: 'AddTravelCompensationCostModalCtrl',
                resolve: {
                    options: function() {
                        return options;
                    }
                }
            });
        } else {
            $modal.open({
                templateUrl: 'views/economyaddcostmodal.html',
                controller: 'AddCostModalCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return options;
                    }
                }
            });
        }
    };

    var downloadCostBasis = function(cost) {
        if (!cost.costfile_id) { return; }
        fileManager.downloadFile(cost.costfile_id);
    };

    $scope.config = {
        getItems: function() {
            return $scope.costs;
        },
        countSuffixList: ['cost', 'costs'],
        searchButtons: [
            { title: 'Confirm all', onClick: function() { confirmCosts(); }, loading: function() { return $scope.loadingStatus.loading; } }
        ],
        rowClass: function(cost) {
            return validateCost(cost) ? 'success' : 'danger';
        },
        rowClick: show,
        columns: [
            { field: 'date', title: 'Payment date', format: 'date', visible: function() { return !isTravelCompensation(); } },
            { field: 'performer.name', title: 'Reference' },
            { field: 'supplier.name', title: 'Supplier', visible: function() { return !isTravelCompensation() && !isOutlay(); } },
            { field: 'departure', title: 'Departure', visible: isTravelCompensation },
            { field: 'amount', title: 'Amount' },
            { field: 'referenceNumber', title: 'OCR-number', visible: isSupplierInvoice, showSum: false },
            { field: 'payoutAccount.name', title: 'Payout account', getValue: function(cost) { return !cost.autoPayout ? (cost.payoutAccount && cost.payoutAccount.name) : util.t('Automatically paid out'); }, visible: function() { return isSupplierInvoice() || isValueCard(); } },
            { field: 'accountingTemplate.name', title: 'Accounting template', getValue: function(cost) { return cost.accountingTemplate && cost.accountingTemplate.name; }, visible: function() { return !isTravelCompensation() && !isValueCard(); } },
            { field: 'comment', title: 'Comment', visible: isTravelCompensation }
        ],
        buttons: [
            { title: 'Show', buttonClass: 'btn-success', onClick: show },
            { title: 'Change', buttonClass: 'btn-warning', onClick: change },
            { title: 'Confirm', buttonClass: 'btn-success', onClick: confirmCosts, visible: validateCost, loading: function() { return $scope.loadingStatus.loading; } },
            { title: 'Reject', buttonClass: 'btn-danger', onClick: reject, loading: function() { return $scope.loadingStatus.loading; } },
            { title: 'Get cost basis', buttonClass: 'btn-success', onClick: downloadCostBasis, visible: function(cost) { return !!cost.costfile_id; } }
        ]
    };

    live.subscribe({
        type: 'cost',
        action: 'change',
        callback: function(__, event) {
            angular.forEach(event.data, $rootScope.transformCost);
            angular.forEach(event.data, function(cost) {
                var index = _.findIndex($scope.costs, function(c) {return c.id === cost.id;});
                if (index == -1) { return; }
                if (cost.status == 'pending') {
                    $scope.costs[index] = cost;
                } else {
                    $scope.costs.splice(index, 1);
                }
            });
        }
    });
}]);

util.controller('EconomyCostListModalCtrl', ['$scope', 'fileManager', 'cost', function($scope, fileManager, cost) {
    $scope.cost = cost;

    $scope.getType = function() {
        var types = { receipt: 'Receipt', supplierinvoice: 'Supplier invoice', travelcompensation: 'Travel bill', outlay: 'Outlay' };
        return types[$scope.cost.type] || '';
    };

    $scope.downloadCostBasis = function() {
        if (!$scope.cost.costfile_id) { return; }
        fileManager.downloadFile($scope.cost.costfile_id);
    };

}]);
